import showMore from "../modules/show-more";

const initBlock = async function( block ) {
	showMore( block );
};

themeUtils.loadBlock( initBlock, "seo-block", ".section-seo-block" );
